<template>
  <div class="page flex-col">    
    <div class="main-container">      
      <PageHeader 
        :current-page="currentPage" 
        :islogin="islogin"
        :active-side="activeSide"
        :avatar="avatar"
        :nickname="nickname"
        @switch-side="handleSwitch"
        @logout="handleLogout"
      />
      <!-- 主内容区 -->
      <div class="content-body">
        <div class="chat-container">
          <!-- 左侧聊天列表面板 -->
          <div class="left-panel">
            <!-- 顶部状态筛选tab -->
            <div class="top-status-tabs">
              <div 
                v-for="tab in statusTabs" 
                :key="tab.value"
                class="status-tab-item"
                :class="{ active: currentStatusTab === tab.value }"
                @click="switchStatusTab(tab.value)">
                {{ tab.label }}
                <span v-if="tab.count" class="tab-count">({{ tab.count }})</span>
              </div>
            </div>

            <!-- 聊天会话列表 -->
            <div class="chat-list-wrapper">
              <div
                v-if="chat_sessions.length > 0"
                class="chat-list">
                <div
                  v-for="session in chat_sessions"
                  :key="session.id"
                  :class="{ 'list-item-active': current_session_id === session.id, 'chat-list-item': true }"
                  @click="select_session(session)"
                  class="chat-list-item">
                  <div class="list-item-content">
                    <!-- 头像容器 -->
                    <div class="avatar-container">
                      <img :src="session.business_avatar || default_avatar"
                         class="message-avatar">
                      <!-- 未读红点 -->
                      <span v-if="session.unreadCount" class="unread-dot"></span>
                    </div>

                    <!-- 聊天信息 -->
                    <div class="chat-info">
                      <div class="name-section">
                        <span class="name">{{ session.title }}</span>
                        <div class="tag-container">
                          <span class="tag company-tag">{{ session.company_name || '未命名' }}</span>
                          <span class="tag job-tag">{{ session.job_title || '未命名' }}</span>
                        </div>
                      </div>
                      <div class="message-section">
                        <span class="last-message">
                          <template v-if="session.last_message_type === 4">
                            <img src="./assets/img/link.png" alt="面试记录" class="interview-record-icon">
                            <span>面试记录</span>
                          </template>
                          <template v-else>
                            {{ session.last_message_content || '暂无消息' }}
                          </template>
                        </span>
                        <span class="timestamp">{{ session.last_message_time }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="empty-list">
                <p>没有更多了</p>
              </div>
            </div>
          </div>

          <!-- 右侧聊天内容面板 -->
          <div class="right-panel">
            <!-- 聊天头部（当前聊天对象信息） -->
            <div class="chat-header" v-if="current_session">
              <!-- 左侧用户信息 -->
              <div class="user-info">
                <div class="user-name">{{ current_session.title }}</div>
                <div class="company-tag" v-if="current_session.company_name">
                  {{ current_session.company_name }}
                </div>
                <div class="typing-status" v-if="typing_status">{{ typing_status }}</div>
              </div>
              
              <!-- 右侧操作按钮 -->
              <div class="action-buttons">
                <button class="action-btn pin-btn" :class="{ active: current_session && current_session.is_pinned == 1 }" @click="togglePin">
                  <img src="./assets/img/top.svg" alt="pin"/>
                  <span>置顶</span>
                </button>
                <button class="action-btn" :class="{ active: current_session && current_session.is_muted == 1 }" @click="toggleMute">
                  <img src="./assets/img/nobother.svg" alt="nobother"/>
                  <span>免打扰</span>
                </button>
                <button class="action-btn" @click="deleteChat">
                  <img src="./assets/img/delete.svg" alt="delete"/>
                  <span>删除</span>
                </button>
                <button class="action-btn report-btn" @click="reportChat">
                  <img src="./assets/img/report.svg" alt="report"/>
                  <span>举报</span>
                </button>
              </div>
            </div>

              <!-- 顶部固定标签（岗位核心信息） -->
                <div v-if="topTag  && topTag.company_name && current_session" class="job-top-bar">
                 <div class="job-top">
                  <div class="job-top-first">
                    <div>
                      <div class="job-title-row">
                        <div class="job-title">{{ topTag.title }}</div>
                        <span v-if="topTag.work_nature" class="pill pill-primary">{{ topTag.work_nature }}</span>
                      </div>
                      <div class="job-meta-row">
                        <span v-for="(lab, idx) in topTag.job_keywords?.split(',')" :key="'l'+idx" class="meta-pill">{{ lab }}</span>
                        <span v-show="topTag.education" :key="topTag.education" class="meta-pill">{{ getEducationLabel(topTag.education) }}</span>
                      </div>
                    </div>
                      <div>
                        <div class="salary">{{ formatSalary(topTag.salary_start, topTag.salary_end, topTag.salary_month) || topTag.salary }}</div>
                      </div>
                  </div>
            
                   <div class="job-top-second">
                    <div class="company-row">
                      <img v-if="topTag.company_logo" :src="topTag.company_logo" class="company-logo" alt="logo" />
                      <div v-else class="company-logo company-logo-placeholder">{{ getCompanyNamePrefix(topTag.company_name) }}</div>
                      <div class="company-info">
                        <div class="company-name">{{ topTag.company_name }}</div>
                        <div class="company-desc text">{{ topTag.category }}</div>
                      </div>
                    </div>
                    <div class="company-detail">
                      <div class="icon-text">
                      <img src="./assets/img/location.svg" alt="location"/>
                      <span>{{ topTag.city }}</span>
                    </div>
                    <div class="icon-text">
                      <!-- <img src="./assets/img/degree.svg" alt="degree"/> -->
                       <div class="icon-text-row">
                        <img style="width: 24px;height: 24px;" :src="topTag.hr_avatar" alt="degree"/>
                        <span>{{ current_session.title }}</span>
                       </div>
                      
                      <span>{{ formatMessageDate(topTag.publish_time) }}</span>
                    </div>
                   </div>
                   </div>
                 </div>
               </div>

              <!-- 聊天消息区域 -->
              <div class="chat-content" v-if="current_session">
              <!-- 消息列表 -->
              <div v-for="(msg, index) in messages" :key="msg.id">
                <!-- 日期分割线 - 只在每条消息前显示，如果日期发生变化 -->
                <div v-if="shouldShowDateDivider(msg, index)" class="date-divider">
                  {{ formatMessageDate(msg.create_time) }}
                </div>

                <div class="message-item"
                  :class="{ mine: is_own_message(msg), other: !is_own_message(msg) }">

                <!-- 对方头像（仅对方消息显示） -->
                <img v-show="!is_own_message(msg)" :src="current_session.avatarUrl ||msg.sender_avatar || default_avatar" alt="对方头像"
                  class="avatar other-avatar">

                <!-- 自己头像（仅自己消息显示） -->
                <img v-show="is_own_message(msg)" :src="current_user_avatar" alt="自己头像" class="avatar my-avatar">

                <div class="message-bubble">
                  <!-- 个人信息聚合型消息（自定义类型: 4） -->
                  <div v-if="msg.message_type === 4" class="profile-aggregate" @click="goToInterviewRecord(msg)">
                    <div class="pa-left">
                      <div class="pa-title">{{ getProfileBlock(msg).interviewPosition || '面试记录' }}</div>
                      <div class="pa-user">
                        <img :src="getProfileBlock(msg).avatar || default_avatar" class="pa-avatar" alt="avatar" />
                        <div class="pa-user-info">
                          <div class="pa-name-row">
                            <span class="pa-name">{{ getProfileBlock(msg).realName || getProfileBlock(msg).nickname }}</span>
                            <span class="pa-sep">·</span>
                            <span class="pa-basic">{{ getProfileBlock(msg).sex  }} ｜ {{ getProfileBlock(msg).age }}岁 ｜ {{ getEducationDetailLabel(getProfileBlock(msg).education) || '本科' }}</span>
                          </div>
                          <div class="pa-graduate" v-if="getProfileBlock(msg).freshman !== undefined">{{ getProfileBlock(msg).freshman ? '应届' : '非应届' }}</div>
                        </div>
                      </div>
                      <div class="pa-tags">
                        <span class="pa-tag">{{ getProfileBlock(msg).school }}</span>
                        <span class="pa-tag">工作年限: {{ getProfileBlock(msg).workYears }}</span>
                      </div>
                    </div>
                    <div class="pa-right">
                      <div class="pa-score">{{ getProfileBlock(msg).evaluationScore ? Math.floor(getProfileBlock(msg).evaluationScore) : '90' }}</div>
                    </div>
                  </div>

                  <!-- 文本消息 -->
                  <p class="message-text" v-if="msg.message_type === 1">
                    {{ msg.content }}
                  </p>

                  <!-- 图片消息 -->
                  <div class="message-image" v-if="msg.message_type === 2">
                    <img :src="msg.file_url || msg.content" :alt="`图片消息 ${index}`" class="message-img"
                      @click="previewImage(msg.file_url || msg.content)">
                  </div>

                  <!-- 文件消息 -->
                  <div class="message-file" v-if="msg.message_type === 3">
                    <a :href="msg.content" target="_blank" class="file-link">
                      <img src="./assets/img/file.png" alt="文件图标" class="file-icon">
                      <div class="file-info">
                        <span class="file-name">{{ getProfileBlock(msg).name }}</span>
                        <span class="file-size">{{ msg.file_size || '' }}</span>
                      </div>
                    </a>
                  </div>

                </div>
                
                <!-- 时间戳和状态显示 -->
                <div class="message-meta">
                  <span class="read-status">
                    {{ is_own_message(msg) ?
                      (msg.status === 2 ? '已读' : (msg.status === 1 ? '已发送' : '发送中'))
                      : format_time(msg.create_time)
                    }}
                    <!-- <template v-if="is_own_message(msg)">
                      <img v-if="msg.status === 2" src="./assets/img/view.png" alt="已读" class="read-icon" />
                      <img v-else-if="msg.status === 1" src="./assets/img/unview.png" alt="未读" class="read-icon" />
                      <span v-else>发送中</span>
                    </template>
                    <template v-else>
                      {{ format_time(msg.create_time) }}
                    </template> -->
                  </span>
                </div>
                </div>
              </div>

            </div>

            <!-- 空状态（未选择聊天对象） -->
            <div class="empty-chat" v-if="!current_session">
              <div class="empty-chat-content">
                <div class="empty-chat-icon">
                  <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="60" cy="60" r="50" fill="url(#emptyGradient)" opacity="0.1"/>
                    <path d="M40 45C40 40.5817 43.5817 37 48 37H72C76.4183 37 80 40.5817 80 45V65C80 69.4183 76.4183 73 72 73H55L45 83V73H48C43.5817 73 40 69.4183 40 65V45Z" fill="url(#emptyGradient)" opacity="0.3"/>
                    <path d="M50 50H70M50 58H65" stroke="url(#emptyGradient)" stroke-width="2" stroke-linecap="round"/>
                    <defs>
                      <linearGradient id="emptyGradient" x1="0" y1="0" x2="120" y2="120" gradientUnits="userSpaceOnUse">
                        <stop offset="0%" stop-color="#7EB4EB"/>
                        <stop offset="100%" stop-color="#B16EF9"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <p class="empty-chat-text">请选择一个会话开始聊天</p>
                <p class="empty-chat-hint">从左侧列表中选择一个会话，开始您的沟通之旅</p>
              </div>
            </div>

            <!-- 输入区域 -->
            <div class="input-bar" v-if="current_session">
              <div class="input-icons">
                <img style="width: 30px;height: 30px;" @click="triggerFrequent" src="./assets/img/noun-frequent.png" alt="常用语">
                <img style="width: 30px;height: 30px;" @click="triggerFileUpload" src="./assets/img/noun-plus.png" alt="附件">
                <img style="width: 30px;height: 30px;" @click="toggleEmojiPanel" src="./assets/img/noun-emoji.png" alt="表情">
                <button class="submit-interview-btn" @click="submitInterviewRecord">投递面试记录</button>
              </div>
              <div class="input-content">
                <textarea 
                  class="input-message" 
                  :placeholder="`发送给${current_session ? current_session.title : ''}`" 
                  v-model="message_content"
                  @keyup.enter="send_message()" 
                  @input="handle_input_typing"
                  rows="2"
                  ref="messageTextarea">
                </textarea>
                <div class="send-button-container">
                  <button class="send-button" @click="send_message()">发送</button>
                </div>
              </div>

              <!-- 隐藏的文件上传输入 -->
              <input type="file" ref="fileInput" class="hidden-file-input" @change="handleFileSelected">
            </div>

            <!-- 常用语面板 -->
            <div class="frequent-panel" v-if="showFrequentPanel" @click.stop>
              <div class="frequent-header">
                <h3 class="frequent-title">常用语</h3>
                <button class="frequent-close" @click="closeFrequentPanel">
                  <span>×</span>
                </button>
              </div>
              <div class="frequent-content">
                <div class="frequent-list">
                  <div v-for="(phrase, index) in frequentPhrases" :key="index" class="frequent-item">
                    <div class="phrase-text">{{ phrase.text }}</div>
                    <div class="phrase-actions">
                      <button class="action-btn" @click="deletePhrase(index)">
                        <img src="./assets/img/delete.svg" alt="delete"/>
                        <span>删除</span>
                      </button>
                      <button class="action-btn modify-btn" @click="modifyPhrase(index)">
                        <img src="./assets/img/change.svg" />
                        <span>修改</span>
                      </button>
                      <button class="action-btn send-btn" @click="sendPhrase(phrase.text)">
                        <span>发送</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="add-phrase-box" @click="addPhrase">
                  <button class="action-btn report-btn">
                  <i class="icon-warning"></i>
                  <span>添加</span>
                </button>
                  
                </div>
              </div>
            </div>

            

            <!-- 表情包面板遮罩 -->
            <div class="emoji-overlay" v-if="showEmojiPanel" @click="toggleEmojiPanel"></div>

            <!-- 表情包面板 -->
            <div class="emoji-panel" v-if="showEmojiPanel" @click.stop>
              <div class="emoji-category">
                <span class="emoji-title">常用表情</span>
                <div class="emoji-grid">
                  <span v-for="emoji in commonEmojis" :key="emoji" class="emoji-item"
                    @click="selectEmoji(emoji)">{{ emoji }}</span>
                </div>
              </div>
              <div class="emoji-category">
                <span class="emoji-title">颜文字</span>
                <div class="emoji-grid">
                  <span v-for="emoji in kaomojis" :key="emoji" class="emoji-item" @click="selectEmoji(emoji)">{{
                    emoji }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片预览模态框 -->
    <div class="image-preview-modal" v-if="previewImageUrl" @click="closeImagePreview">
      <div class="preview-content" @click.stop>
        <img :src="previewImageUrl" alt="图片预览" class="preview-img">
      </div>
    </div>

    <!-- 修改常用语弹框 -->
    <el-dialog
      :visible.sync="showModifyModal"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :show-close="false"
      custom-class="modify-phrase-dialog"
    >
      <div slot="title" class="dialog-title">
        <span class="title-text">{{ modifyIndex === -1 ? '添加常用语' : '请修改您的常用语' }}</span>
        <div>
          <img src="./assets/img/close.png" alt="关闭图标" @click="closeModifyModal"/>
        </div>
      </div>
      <div class="dialog-content">
        <el-input
          v-model="modifyText"
          type="textarea"
          :rows="4"
          placeholder="请输入常用语"
          class="modify-textarea"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="footer-left">
          <el-button @click="closeModifyModal">返回</el-button>
        </div>
        <div class="footer-right">
          <el-button 
            @click="clearModifyText"
            :disabled="modifyIndex === -1 && !modifyText.trim()"
          >清空</el-button>
          <el-button 
            type="primary" 
            @click="saveModifyPhrase"
            :disabled="modifyIndex === -1 && !modifyText.trim()"
          >{{ modifyIndex === -1 ? '添加' : '保存' }}</el-button>
        </div>
      </div>
    </el-dialog>

    <SubmitMaterialDialog 
      :visible.sync="showInterviewSelectModal"
      :as-dialog="false"
      :target-user-id="current_session && current_session.business_id"
      :job-id="current_session && current_session.jobId"
      :job="topTag"
      @submit="handleSubmitMaterials"
    />

    <!-- 自定义删除聊天弹框 -->
    <div v-if="showDeleteDialog" class="delete-dialog-overlay" @click="showDeleteDialog=false">
      <div class="delete-dialog" @click.stop>
        <img :src="tipImgUrl" alt="tip" class="popup-image" />
        <div class="font-color fs-24">确定要删除聊天吗?</div>
        <div class="dd-desc">删除后将清空聊天记录</div>
        <div class="dd-desc">并且将当前聊天从聊天列表中删除</div>
        <div class="dd-actions">
          <button class="dd-btn dd-cancel" @click="showDeleteDialog=false">我再想想</button>
          <button class="dd-btn button-color" @click="confirmDeleteChat">确定删除</button>
        </div>
      </div>
    </div>

    <!-- 自定义举报聊天弹框 -->
    <el-dialog
      :visible.sync="showReportDialog"
      custom-class="report-el-dialog"
      width="560px"
      :show-close="false"
      :close-on-click-modal="true"
      @close="handleReportDialogClose"
    >
      <template slot="title">
        <div class="dialog-title">
          <span class="title-text">举报聊天</span>
          <img src="./assets/img/close.png" alt="关闭图标" @click="handleReportDialogClose"/>
        </div>
       
      </template>

      <div class="report-intro">举报不良内容，共建健康社区环境</div>
      <div class="report-intro">已选聊天：与{{ current_session ? current_session.title : '' }}的对话</div>

      <el-form ref="reportFormRef" :model="reportForm" :rules="reportRules" label-position="top" class="report-form">
        <el-form-item prop="reportType" label-width="0">
          <el-select v-model="reportForm.reportType" placeholder="请选择举报类型">
            <el-option v-for="type in reportTypes" :key="type.value" :label="type.label" :value="type.value" />
          </el-select>
        </el-form-item>

        <el-form-item prop="description" label-width="0">
          <el-input type="textarea" :rows="4" v-model="reportForm.description" placeholder="详细的描述有助于我们更快处理您的举报" />
        </el-form-item>

        <el-form-item label="上传相关证据截图（最多3张）" prop="images">
          <el-upload
            action="#"
            :auto-upload="false"
            list-type="picture-card"
            :limit="3"
            accept="image/*"
            :file-list="reportForm.images"
            :on-change="handleReportImageChange"
            :on-remove="handleReportImageRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
         <div class="report-footer">
          <el-button @click="handleReportDialogClose">取消</el-button>
        <el-button type="primary" class="button-color" :loading="uploadingImages" :disabled="uploadingImages" @click="submitReportForm">确认举报</el-button>
         </div>
      </el-form>
    </el-dialog>

    <!-- 无面试记录提示弹框（复用删除弹框风格） -->
    
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { chatApi, websocketUtil, commonPhraseApi, sessionApi } from '@/api/chat'
import { wsUploadFile, lxUploadFile } from '@/api/upload'
import { getJobInfo } from '@/api/job'
import SubmitMaterialDialog from '@/components/SubmitMaterialDialog/index.vue'
import PageHeader from '@/components/PageHeader/index.vue'
import { formatSalary } from '@/constants/jobConstants'
import {  getEducationDetailLabel, getEducationLabel } from '@/constants/jobConstants'
import { getUserInfo } from '@/api/user'
export default {
  components: { SubmitMaterialDialog, PageHeader },
  data () {
    return {
            showJobDialog: false,
            allscore: 0, // 总分
            position: '',
            // 顶部状态筛选tab
            currentStatusTab: 'all', // 当前选中的状态tab
            statusTabs: [
              { label: '全部', value: 'all', count: null },
              { label: '已读', value: 'communicating', count: null },
              { label: '未读', value: 'unread', count: null }
            ],
      // Header 相关
      currentPage: 'chatings',
      islogin: false,
      activeSide: 'seek',
      nickname: '',
      // 当前用户
      current_user_id: null,
      current_user_type: 1,
      current_user_name: '我',
      current_user_avatar: '',

      // websocket
      websocket: null,
      is_connected: false,
      heartbeat_timer: null,
      typing_timer: null,
      typing_status: '',

      // 聊天
      current_session_id: null,
      current_session: null,
      messages: [],
      message_content: '',

      // 会话列表
      chat_sessions: [],
      search_query: '',
      pagination: { page_no: 1, page_size: 50, total: 0 },

      // 上传
      uploading: false,
      uploadProgress: 0,
      pendingFiles: [],

      // 表情
      showEmojiPanel: false,
      commonEmojis: ['😀', '😂', '😍', '👍', '👏', '🙏', '😊', '😢', '😠', '🎉', '🤔', '🙄', '😘', '😜', '🤗', '😴', '😎', '😱', '🤩', '🙌'],
      kaomojis: ['(≧∇≦)ﾉ', '(｡•̀ᴗ-)✧', '(*^▽^*)', '( ´･ᴗ･` )', 'Σ(°△°|||)', '(；¬＿¬)', '（￣▽￣）', '(*≧▽≦)', '(≧∀≦)ゞ'],

      // 常用语
      showFrequentPanel: false,
      frequentPhrases: [],
      splitIcon: '$$$$$$',
      // 修改弹框相关
      showModifyModal: false,
      modifyText: '',
      modifyIndex: -1,

      // 预览
      previewImageUrl: '',

      // 面试记录选择弹框
      showInterviewSelectModal: false,
      interviewRecords: [],
      selectedInterviewId: null,
      loadingInterviewRecords: false,
      deliveringInterview: false,

      // 顶部岗位信息（可替换为接口数据）
      topTag: {},

      baseUrl: 'http://test.yuugeai.com/api/uploads/',
      default_avatar: require('./assets/img/default-avatar.png'),
      scoreImg: require('@/views/Interview_Analysis/assets/img/score.png'),

      // 删除确认弹框
      showDeleteDialog: false,
      tipImgUrl: require('../interview_ing/assets/img/tips.png'),

      // 举报聊天弹框
      showReportDialog: false,
      reportForm: {
        reportType: '',
        description: '',
        images: [] // 存储文件对象
      },
      reportRules: {
        reportType: [{ required: true, message: '请选择举报类型', trigger: 'change' }],
        description: [{ min: 0, max: 500, message: '描述过长', trigger: 'blur' }],
        images: [{ required: true, message: '请至少上传一张证据截图' }]
      },
      reportTypes: [
        {
          value: 1,
          label: '违反(在招聘过程中存在违法/违规言行或涉及政治等敏感)',
        },
        {
          value: 2,
          label: '违反劳动法(在招聘过程中存在违反劳动法的情况)',
        },
        {
          value: 3,
          label: '向求职者收费(涉及以各种名义直接或变相收取求职者费用)',
        },
        {
          value: 4,
          label: '涉嫌诈骗(在招聘过程中诱导求职者投资或诈骗求职者)',
        },
        {
          value: 5,
          label: '职位虚假(实际沟通的岗位情况与招聘者发布的职位信息不符)',
        },
        {
          value: 6,
          label: '招聘者身份虚假(招聘者不是该招聘公司的员工)',
        },
        {
          value: 7,
          label: '色情低俗(招聘者所招岗位或沟通言行中存在色情低俗情况)',
        },
        {
          value: 8,
          label: '人身攻击/歧视(招聘过程中存在辱骂、歧视、骚扰等情况)',
        },
        {
          value: 9,
          label: '求职体验问题(招聘者及其公司存在影响求职体验的情况)',
        }
      ],
      uploadingImages: false,
    }
  },
  computed: {
    ...mapState('user', ['avatar']),
    grouped_messages () {
      const groups = {}
      this.messages.forEach(msg => {
        const date = this.format_date(msg.create_time)
        if (!groups[date]) groups[date] = []
        groups[date].push(msg)
      })
      return groups
    },
  },
  created () {
    this.init_current_user()
    this.connect_websocket()
    this.load_chat_sessions()
    this.loadFrequentPhrases()
  },

  beforeDestroy () {
    this.disconnect_websocket()
    if (this.typing_timer) clearTimeout(this.typing_timer)
  },
  methods: {
    getEducationDetailLabel,
    getEducationLabel,
    formatSalary,
    goToInterviewRecord(msg){
      if (msg && msg.message_type === 4) {
        let targetId = msg.id
        const content = msg.content
        try {
          const data = typeof content === 'string' ? JSON.parse(content) : content
          if (data && data.interviewId) {
            targetId = data.interviewId
          }
        } catch (e) {
          // 非 JSON 字符串，忽略
        }
        this.$router.push({ name: 'Interview_Analysis', params: { id: targetId } })
      }
    },
    // 处理常用语
    triggerFrequent(){
      this.showFrequentPanel = !this.showFrequentPanel;
      if (this.showFrequentPanel) {
        this.showEmojiPanel = false; // 关闭表情包面板
      }
    },

    // 关闭常用语面板
    closeFrequentPanel() {
      this.showFrequentPanel = false;
    },

    // 发送常用语
    sendPhrase(text) {
      this.message_content = text;
      this.send_message();
      this.closeFrequentPanel();
    },

    // 加载常用语
    async loadFrequentPhrases() {
      try {
        const response = await commonPhraseApi.getAllPhrases();
        if (response && response.data && response.data.code === 1) {
          const phrases = response.data.data || [];
          // 将接口返回的数据转换为组件需要的格式
          this.frequentPhrases = phrases.map(item => ({
            id: item.id,
            text: item.content || item.text || item.phrase || ''
          })).filter(item => item.text); // 过滤掉空内容
        } else {
          this.frequentPhrases = [];
        }
      } catch (error) {
        console.error('获取常用语失败：', error)
        this.frequentPhrases = [];
      }
    },

    // 将后端返回的字符串转换为数组
    convertGreetingsToArray(greetings) {
      if (!greetings) return [];
      if (typeof greetings === 'string') {
        if (greetings.trim() === '') return [];
        return greetings?.split(this.splitIcon).filter(item => item.trim() !== '');
      }
      if (Array.isArray(greetings)) {
        return greetings.length > 0 ? greetings : [];
      }
      return [];
    },

    // 将前端数组转换为后端需要的字符串
    convertGreetingsToString(greetings) {
      if (!greetings || !Array.isArray(greetings)) return '';
      const validGreetings = greetings.filter(item => item && item.trim() !== '');
      return validGreetings.join(this.splitIcon);
    },

    // 删除常用语
    async deletePhrase(index) {
      try {
        const phrase = this.frequentPhrases[index];
        if (!phrase || !phrase.id) {
          this.$message.error('常用语数据异常，无法删除');
          return;
        }

        const response = await commonPhraseApi.deletePhrase(phrase.id);
        if (response && response.data && response.data.code === 1) {
          // 删除成功后重新加载列表
          await this.loadFrequentPhrases();
          this.$message.success('删除成功');
        } else {
          this.$message.error(response?.data?.msg || '删除失败');
        }
      } catch (error) {
        console.error('删除常用语失败:', error);
        this.$message.error('删除失败，请重试');
      }
    },

    // 修改常用语
    modifyPhrase(index) {
      this.modifyIndex = index;
      this.modifyText = this.frequentPhrases[index].text;
      this.showModifyModal = true;
    },

    // 关闭修改弹框
    closeModifyModal() {
      this.showModifyModal = false;
      this.modifyText = '';
      this.modifyIndex = -1;
    },

    // 清空修改文本
    clearModifyText() {
      this.modifyText = '';
    },

    // 保存修改的常用语
    async saveModifyPhrase() {
      if (!this.modifyText.trim()) {
        this.$message.warning('请输入常用语内容');
        return;
      }

      if (this.modifyIndex === -1) {
        // 添加模式
        if (this.frequentPhrases.length >= 3) {
          this.$message.warning('最多只能添加3条常用语');
          return;
        }
        
        try {
          const response = await commonPhraseApi.createPhrase({
            content: this.modifyText.trim()
          });
          if (response && response.data && response.data.code === 1) {
            // 添加成功后重新加载列表
            await this.loadFrequentPhrases();
            this.closeModifyModal();
            this.$message.success('添加成功');
          } else {
            this.$message.error(response?.data?.msg || '添加失败');
          }
        } catch (error) {
          console.error('添加常用语失败:', error);
          this.$message.error('添加失败，请重试');
        }
      } else {
        // 编辑模式
        const currentPhrase = this.frequentPhrases[this.modifyIndex];
        if (!currentPhrase || !currentPhrase.id) {
          return;
        }

        if (this.modifyText.trim() === currentPhrase.text) {
          this.closeModifyModal();
          return;
        }

        try {
          const response = await commonPhraseApi.updatePhrase(currentPhrase.id, {
            content: this.modifyText.trim()
          });
          if (response && response.data && response.data.code === 1) {
            // 更新成功后重新加载列表
            await this.loadFrequentPhrases();
            this.closeModifyModal();
            this.$message.success('修改成功');
          } else {
            this.$message.error(response?.data?.msg || '修改失败');
          }
        } catch (error) {
          console.error('修改常用语失败:', error);
          this.$message.error('修改失败，请重试');
        }
      }
    },

    // 添加常用语
    addPhrase() {
      this.modifyIndex = -1; // -1表示添加模式
      this.modifyText = '';
      this.showModifyModal = true;
    },

    // 投递面试记录（仅打开公共组件）
    async submitInterviewRecord() {
      if (!this.current_session) {
        this.$message.warning('请先选择一个会话');
        return;
      }
      
      // 检查是否已投递过
      const jobId = this.current_session.jobId
      const targetUserId = this.current_session.business_id
      
      if (!jobId || !targetUserId) {
        this.$message.warning('会话信息不完整，无法投递');
        return;
      }
      this.showInterviewSelectModal = true
    },

    // 格式化面试记录日期
    formatInterviewDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 公共组件提交回调
    async handleSubmitMaterials(payload, done, fail) {
      if (!this.current_session) { this.$message.warning('请先选择一个会话'); fail && fail(); return }
      this.deliveringInterview = true
      this.load_chat_messages()
      try {
        done && done()
        
      } catch (e) {
        console.error(e)
        this.$message.error('投递失败，请重试')
        fail && fail()
      } finally {
        this.deliveringInterview = false
        this.showInterviewSelectModal = false

      }
    },

    // 置顶聊天
    togglePin() {
      if (!this.current_session) return;
      const currentPinned = this.current_session.is_pinned == 1;
      const newPinned = !currentPinned;
      const sessionId = this.current_session.id;
      sessionApi.operate({ session_id: sessionId, is_pinned: newPinned ? 1 : 0 })
        .then(() => {
          this.$message.success(newPinned ? '已置顶' : '已取消置顶');
          // 重新获取会话列表，确保置顶的会话排在前面
          return this.load_chat_sessions();
        })
        .then(() => {
          // 重新选中当前会话
          const updatedSession = this.chat_sessions.find(s => s.id === sessionId);
          if (updatedSession) {
            this.select_session(updatedSession);
          }
        })
        .catch((err) => {
          console.error('置顶操作失败:', err);
          this.$message.error('置顶失败，请重试');
        })
    },

    // 免打扰
    toggleMute() {
      if (!this.current_session) return;
      const currentMuted = this.current_session.is_muted == 1;
      const newMuted = !currentMuted;
      const sessionId = this.current_session.id;
      sessionApi.operate({ session_id: sessionId, is_muted: newMuted ? 1 : 0 })
        .then(() => {
          // 直接更新当前会话状态
          this.$set(this.current_session, 'is_muted', newMuted ? 1 : 0);
          // 同时更新会话列表中的对应会话
          const sessionIndex = this.chat_sessions.findIndex(s => s.id === sessionId);
          if (sessionIndex !== -1) {
            this.$set(this.chat_sessions[sessionIndex], 'is_muted', newMuted ? 1 : 0);
          }
          this.$message.success(newMuted ? '已开启免打扰' : '已关闭免打扰');
        })
        .catch((err) => {
          console.error('免打扰操作失败:', err);
          this.$message.error('免打扰失败，请重试');
        })
    },

    // 删除聊天
    deleteChat() {
      if (this.current_session) {
        this.showDeleteDialog = true;
      }
    },

    // 举报聊天
    reportChat() {
      if (this.current_session) {
        this.resetReportForm();
        this.showReportDialog = true;
      }
    },

    // 关闭举报弹框
    handleReportDialogClose() {
      this.showReportDialog = false;
      this.resetReportForm();
    },

    confirmDeleteChat() {
      if (!this.current_session) return;
      const sessionId = this.current_session.id;
      sessionApi.operate({ session_id: sessionId, is_deleted: 1 })
        .then(() => {
          this.$message.success('删除成功');
          // 清空当前会话窗口
          this.current_session = null;
          this.current_session_id = null;
          this.messages = [];
          this.message_content = '';
          this.topTag = {};
          // 删除成功后刷新会话列表
          this.load_chat_sessions();
          this.showDeleteDialog = false;
        })
        .catch((err) => {
          console.error('删除聊天失败:', err);
          this.$message.error('删除失败，请重试');
        })
    },


    // 获取子类型列表
    getSubTypes(reportType) {
      const type = this.reportTypes.find(t => t.value === reportType);
      return type ? type.subTypes : [];
    },

    // 处理图片上传
    handleReportImageChange(file, fileList) {
      if (fileList.length > 3) {
        this.$message.warning('最多只能上传3张图片');
        return;
      }
      this.reportForm.images = fileList;
    },

    // 处理图片删除
    handleReportImageRemove(file, fileList) {
      this.reportForm.images = fileList;
    },

    // 验证并提交举报表单
    submitReportForm() {
      this.$refs.reportFormRef && this.$refs.reportFormRef.validate(async (valid) => {
        if (!valid) return;
        if (this.reportForm.images.length === 0) {
          this.$message.warning('请至少上传一张证据截图');
          return;
        }
        await this.confirmReportChat();
      });
    },

    // 确认举报
    async confirmReportChat() {
      this.uploadingImages = true;
      try {
        // 上传所有图片
        const imageUrls = [];
        for (const fileObj of this.reportForm.images) {
          const file = fileObj.raw || fileObj;
          try {
            const formData = new FormData();
            formData.append('file', file);
            const uploadRes = await lxUploadFile(formData);
            if (uploadRes.data && uploadRes.data.code === 1 && uploadRes.data.data && uploadRes.data.data.url) {
              imageUrls.push(uploadRes.data.data.url);
            } else {
              throw new Error(uploadRes.data?.msg || '上传失败');
            }
          } catch (error) {
            this.$message.error(`图片上传失败: ${file.name}`);
            this.uploadingImages = false;
            return;
          }
        }

        // 调用举报接口
        const reportData = {
          session_id: this.current_session ? this.current_session.id : null,
          report_type: this.reportForm.reportType,
          report_reason: this.reportForm.description,
          images_url: imageUrls.join(',')
        };
        try {
          const res = await sessionApi.report(reportData)
          if (res && res.data && res.data.code === 1) {
            this.$message.success('举报成功，我们会尽快处理');
            this.resetReportForm();
            this.showReportDialog = false;
          } else {
            throw new Error(res?.data?.msg || '举报失败')
          }
        } catch (e) {
          this.$message.error(e.message || '举报失败，请重试')
          this.uploadingImages = false
          return
        }
      } catch (error) {
        console.error('举报失败:', error);
        this.$message.error('举报失败，请重试');
      } finally {
        this.uploadingImages = false;
      }
    },

    // 重置表单
    resetReportForm() {
      this.reportForm = {
        reportType: '',
        description: '',
        images: []
      };
    },

    // 判断是否应该显示日期分割线
    shouldShowDateDivider(msg, index) {
      if (index === 0) return true; // 第一条消息总是显示日期
      
      const currentDate = this.formatMessageDate(msg.create_time);
      const prevMsg = this.messages[index - 1];
      const prevDate = this.formatMessageDate(prevMsg.create_time);
      
      return currentDate !== prevDate;
    },

    // 格式化消息日期
    formatMessageDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}/${month}/${day}`;
    },

    // 切换顶部状态筛选tab
    switchStatusTab(status) {
      if (this.currentStatusTab === status) {
        return;
      }
      this.currentStatusTab = status;
      // 重新加载会话列表
      this.load_chat_sessions();
      
      // 清空当前选中的会话
      this.current_session_id = null;
      this.current_session = null;
      this.messages = [];
    },
    /* ---------- 用户初始化 ---------- */
    async init_current_user () {
      try {
        const res = await getUserInfo()
        if (res.data.code === 1) {
          const data = res.data.data || {}
          this.current_user_id = data.id
          this.current_user_name = data.nickname || data.real_name || '我'
          this.current_user_avatar = data.avatar || ''
          this.nickname = data.real_name || data.nickname || ''
          this.islogin = true
        } else {
          this.islogin = false
          this.nickname = ''
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        this.islogin = false
        this.nickname = ''
      }
    },
    // Header 相关方法
    handleSwitch(side) {
      this.activeSide = side;
    },
    handleLogout() {
      this.islogin = false
      this.nickname = ''
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      this.$message.success('已退出登录')
      this.$router.push('/')
    },

    /* ---------- websocket ---------- */
    connect_websocket () {
      if (!this.current_user_id) { setTimeout(() => this.connect_websocket(), 1000); return }
      this.websocket = websocketUtil.createWebSocket(this.current_user_id, this.current_user_type)
      
      this.websocket.onopen = () => {
        this.is_connected = true
        this.start_heartbeat()
        this.processPendingFiles()
      }
      this.websocket.onmessage = (e) => this.handle_websocket_message(e.data)
      this.websocket.onclose = () => {
        this.is_connected = false
        this.stop_heartbeat()
        setTimeout(() => this.connect_websocket(), 3000)
      }
      
      this.websocket.onerror = (error) => {
        console.error('WebSocket连接错误:', error);
        this.is_connected = false
      }
    },
    disconnect_websocket () {
      this.websocket && this.websocket.close()
      this.stop_heartbeat()
    },
    start_heartbeat () {
      this.heartbeat_timer && clearInterval(this.heartbeat_timer)
      this.heartbeat_timer = setInterval(() => {
        if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
          const payload = {
            type: 'heartbeat',
            userId: this.current_user_id,
            userType: this.current_user_type
          }
          try {
            this.websocket.send(JSON.stringify(payload))
          } catch (e) {
            console.warn('心跳发送失败:', e)
          }
        }
      }, 30000)
    },
    stop_heartbeat () {
      this.heartbeat_timer && clearInterval(this.heartbeat_timer)
    },
    handle_websocket_message (data) {
      try {
        const msg = JSON.parse(data)
        switch (msg.type) {
          case 'heartbeat': break
          case 'message': this.handle_new_message(msg); break
          case 'typing':
            this.typing_status = '对方正在输入...'
            this.reset_typing_status()
            break
          default: break
        }
      } catch { /* ignore */ }
    },

    /* ---------- 会话列表 ---------- */
    load_chat_sessions () {
      const params = { page_no: 1, page_size: 50 };
      
      // 根据顶部状态tab添加不同的参数
      if (this.currentStatusTab === 'communicating') {
        // 已读：有消息但未完成的状态
        params.messageStatus = 1;
      } else if (this.currentStatusTab === 'unread') {
        params.messageStatus = 0; // 未读消息
      }

      // 岗位筛选
      if (this.selectedJobId) {
        params.job_id = this.selectedJobId;
      }

      // 搜索关键词
      if (this.search_query && this.search_query.trim()) {
        params.userName = this.search_query.trim()
      }
      
      return chatApi.getSessions(params).then(res => {
        if (res.data.code !== 1) return Promise.resolve()
        let sessions = res.data.data?.records.map(s => ({
          ...s,
          title: s.business_name || '企业用户' + s.business_id,
          unreadCount: s.user_unread_count || 0,
          company_name: s.company_name || '未知',
          jobId: s.job_id,
          job_title: s.job_title || '',
          job_salary: s.job_salary || '',
          is_pinned: s.is_pinned || 0,
          is_muted: s.is_muted || 0
        })) || []
        
        
        this.chat_sessions = sessions
        return Promise.resolve()
      })
    },

    /* ---------- 选择会话 ---------- */
    select_session (session) {
      this.current_session_id = session.id
      this.current_session = session
      this.messages = []
      this.message_content = ''
      this.get_or_create_session({ target_user_id: session.business_id, job_id: session.jobId })
      // 开启会话的情况下调取岗位信息
      if (session && session.jobId) {
        this.fetchJobTopTag(session.jobId)
      } else {
        this.topTag = {}
      }
    },
    async fetchJobTopTag (jobId) {
      try {
        const res = await getJobInfo({ id: jobId })
        const info = res?.data?.data
        if (!info) { this.topTag = {}; return }
        this.topTag = info
      } catch (e) {
        console.error('获取职位信息失败', e)
        this.topTag = {}
      }
    },
    // 获取公司名前四个字作为占位符
    getCompanyNamePrefix(companyName) {
      if (!companyName) return '公司';
      // 去掉地名前缀（匹配"XX市"、"XX省"等格式）
      let cleanName = companyName.replace(/^[^省市区县]+[省市县区]/, '');
      return cleanName.substring(0, 4) || companyName.substring(0, 4) || '公司';
    },
    get_or_create_session (params) {
      chatApi.getOrCreateSession({
        target_user_type: 2,
        target_user_id: params.target_user_id,
        job_id: params.job_id
      }).then(res => {
        if (res.data.code === 1) {
          this.current_session_id = res.data.data.id
          this.load_chat_messages()
          this.mark_as_read()
        }
      })
    },
    load_chat_messages () {
      if (!this.current_session_id) return
      chatApi.getMessages({ sessionId: this.current_session_id, pageNo: 1, pageSize: 50 })
        .then(res => {
          if (res.data.code !== 1) return
          this.messages = res.data.data?.reverse()?.map(m => ({ ...m, status: 1 }))
          this.$nextTick(() => this.scroll_to_bottom())
        })
    },
    mark_as_read () {
      if (!this.current_session_id) return
      chatApi.markAsRead(this.current_session_id)
      const idx = this.chat_sessions.findIndex(s => s.id === this.current_session_id)
      if (idx !== -1) this.chat_sessions[idx].unreadCount = 0
    },

    /* ---------- 发送消息 ---------- */
    send_message () {
      const content = this.message_content.trim()
      if (!content || !this.current_session) return
      this.message_content = ''
      this.showEmojiPanel = false

      const temp_msg = {
        id: `temp_${Date.now()}`,
        content,
        create_time: new Date().toISOString(),
        sender_id: this.current_user_id,
        sender_type: this.current_user_type,
        receiver_id: this.current_session.business_id,
        receiver_type: 2,
        session_id: this.current_session_id,
        message_type: 1,
        status: 0,
        job_id: this.current_session.jobId
      }
      this.messages.push(temp_msg)
      this.update_session_last_message(temp_msg)
      this.scroll_to_bottom()

      const msg_data = {
        type: 'chat',
        sessionId: this.current_session_id,
        receiverId: this.current_session.business_id,
        receiverType: 2,
        senderId: this.current_user_id,
        content,
        messageType: 1,
        jobId: this.current_session.jobId
      }

      if (this.is_connected && this.websocket.readyState === WebSocket.OPEN) {
        websocketUtil.sendChatMessage(this.websocket, msg_data)
      } else {
        chatApi.sendMessage(msg_data).then(res => {
          if (res.data.code === 1) {
            const idx = this.messages.findIndex(m => m.id === temp_msg.id)
            if (idx !== -1) {
              this.messages[idx] = res.data.data;
            } else {
              this.messages.push(res.data.data);
            }
            this.scroll_to_bottom();
          }
        }).catch(err => {
          console.error('发送离线消息失败', err);
          // 发送失败，更新消息状态
          const msg_index = this.messages.findIndex(m => m.id === msg_data.id);
          if (msg_index !== -1) {
            this.messages[msg_index].status = -1; // 发送失败状态
          }
        });
      }
    },

    update_session_last_message (msg) {
      const idx = this.chat_sessions.findIndex(s => s.id === msg.session_id)
      if (idx !== -1) {
        this.$set(this.chat_sessions[idx], 'last_message_content', msg.content)
        this.$set(this.chat_sessions[idx], 'last_message_time', this.format_time(msg.create_time))
        const session = this.chat_sessions.splice(idx, 1)[0]
        this.chat_sessions.unshift(session)
      }
    },

    /* ---------- 文件 ---------- */
    triggerFileUpload () { this.$refs.fileInput.click() },
    handleFileSelected (e) {
      const file = e.target.files[0]
      if (!file) return
      e.target.value = ''
      this.uploadFile(file)
    },
    uploadFile (file) {
      if (!this.current_session) return
      // 判断文件类型
      const isImage = file.type.startsWith('image/');
      
      const messageType = isImage ? 2 : 3;
      const temp_msg = {
        id: `temp_${Date.now()}`,
        content: file.name,
        create_time: new Date().toISOString(),
        sender_id: this.current_user_id,
        sender_type: this.current_user_type,
        receiver_id: this.current_session.business_id,
        receiver_type: 2,
        session_id: this.current_session_id,
        message_type: messageType,
        status: 0,
        file_size: this.formatFileSize(file.size)
      }
      this.messages.push(temp_msg)
      this.update_session_last_message(temp_msg)
      this.scroll_to_bottom()

      if (this.is_connected && this.websocket.readyState === WebSocket.OPEN) {
        this.uploadFileOnline(file, temp_msg)
      } else {
        this.pendingFiles.push({ file, tempMsg: temp_msg })
      }
    },
    uploadFileOnline (file, temp_msg) {
      this.uploading = true
      this.uploadProgress = 0
      const isImage = file.type.startsWith('image/');
      const messageType = isImage ? 2 : 3;
      const params = {
        senderId: this.current_user_id,
        senderType: this.current_user_type,
        receiverId: this.current_session.business_id,
        receiverType: 1,
        messageType,
        jobId: this.current_session.jobId,
        dir: this.isImageFile(file.name) ? 'images' : 'files'
      }
      const formData = new FormData()
      formData.append('file', file)
      wsUploadFile(params, formData, e => {
        this.uploadProgress = Math.round((e.loaded / e.total) * 100)
      })
        .then(res => {
          this.uploading = false
          if (res.data.code === 1 && res.data.data?.url) {
            const idx = this.messages.findIndex(m => m.id === temp_msg.id)
            if (idx !== -1) {
              this.$set(this.messages, idx, {
                ...this.messages[idx],
                status: 1,
                file_url: res.data.data.url
              })
            }
            const fileMsg = {
              type: 'chat',
              receiverId: this.current_session.business_id,
              receiverType: 2,
              content: res.data.data.url,
              messageType: messageType,
              jobId: this.current_session.jobId,
              fileUrl: res.data.data.url,
              fileSize: this.formatFileSize(file.size)
            }
            websocketUtil.sendChatMessage(this.websocket, fileMsg)
          } else {
            this.pendingFiles.push({ file, tempMsg: temp_msg })
            this.updateFileStatus(temp_msg.id, -1)
          }
        })
        .catch(() => {
          this.uploading = false
          this.pendingFiles.push({ file, tempMsg: temp_msg })
          this.updateFileStatus(temp_msg.id, -1)
        })
    },
    processPendingFiles () {
      if (!this.pendingFiles.length) return
      const sendNext = () => {
        if (!this.pendingFiles.length) return
        const { file, tempMsg } = this.pendingFiles.shift()
        this.uploadFileOnline(file, tempMsg)
      }
      sendNext()
    },
    updateFileStatus (id, status) {
      const idx = this.messages.findIndex(m => m.id === id)
      if (idx !== -1) this.$set(this.messages, idx, { ...this.messages[idx], status })
    },

    /* ---------- 表情 ---------- */
    toggleEmojiPanel () { this.showEmojiPanel = !this.showEmojiPanel },
    selectEmoji (emoji) {
      this.message_content += emoji
      this.showEmojiPanel = false
    },

    /* ---------- 工具 ---------- */
    handle_search () {
      this.load_chat_sessions()
    },
    view_current_user_resume () { /* 可扩展查看简历 */ },
    previewImage (url) { this.previewImageUrl = url },
    closeImagePreview () { this.previewImageUrl = '' },
    isImageFile (name) {
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(name.split('.').pop().toLowerCase())
    },
    getFileName (url) { return url ? url.substring(url.lastIndexOf('/') + 1) : '' },
    formatFileSize (bytes) {
      if (!bytes) return ''
      const k = 1024
      const s = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + s[i]
    },

    // 解析个人信息聚合消息体：支持 content 为 JSON 字符串或 msg.profile 字段
    getProfileBlock (msg) {
      if (!msg) return {}
      if (msg.content && typeof msg.content === 'object') return msg.content
      try {
        if (msg.content && typeof msg.content === 'string' && (msg.content.startsWith('{') || msg.content.startsWith('['))) {
          const data = JSON.parse(msg.content)
          return Array.isArray(data) ? (data[0] || {}) : (data || {})
        }
      } catch (e) { /* ignore parse error */ }
      return {}
    },

    /* ---------- 消息处理 ---------- */
    handle_new_message (msg) {
      const fMsg = {
        id: msg.id || `recv_${Date.now()}`,
        content: msg.content,
        create_time: msg.createTime || new Date().toISOString(),
        sender_id: msg.senderId,
        sender_type: msg.senderType,
        receiver_id: msg.receiverId,
        receiver_type: msg.receiverType,
        session_id: msg.sessionId,
        file_url: msg.fileUrl || '',
        file_size: msg.fileSize || '',
        message_type: msg.messageType || 1,
        status: 1
      }

      // 忽略自己发送的
      if (fMsg.sender_id === this.current_user_id && fMsg.sender_type === this.current_user_type) {
        const idx = this.messages.findIndex(m => m.content === fMsg.content && m.status === 0)
        if (idx !== -1) this.$set(this.messages, idx, { ...fMsg, status: 1 })
        return
      }

      // 当前会话
      if (fMsg.session_id === this.current_session_id) {
        this.messages.push(fMsg)
        this.scroll_to_bottom()
        this.mark_as_read()
      } else {
        // 更新会话列表
        this.update_session_last_message(fMsg)
      }
    },

    /* ---------- 输入状态 ---------- */
    handle_input_typing () {
      if (!this.current_session || !this.websocket || this.websocket.readyState !== WebSocket.OPEN) return
      if (this.typing_timer) clearTimeout(this.typing_timer)
      this.websocket.send(JSON.stringify({ type: 'typing', receiverId: this.current_session.business_id, receiverType: 2 }))
      this.typing_timer = setTimeout(() => { this.typing_status = '' }, 3000)
    },
    reset_typing_status () {
      if (this.typing_timer) clearTimeout(this.typing_timer)
      this.typing_timer = setTimeout(() => { this.typing_status = '' }, 3000)
    },

    /* ---------- 判断是否自己消息 ---------- */
    is_own_message (msg) {
      return msg.sender_id === this.current_user_id && msg.sender_type === this.current_user_type
    },

    /* ---------- 格式化时间 ---------- */
    format_time (ts) {
      if (!ts) return ''
      const d = new Date(ts)
      return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    },
    format_date (ts) {
      if (!ts) return ''
      const d = new Date(ts)
      const today = new Date()
      const yesterday = new Date(today); yesterday.setDate(today.getDate() - 1)
      if (d.toDateString() === today.toDateString()) return '今天'
      if (d.toDateString() === yesterday.toDateString()) return '昨天'
      return d.toLocaleDateString()
    },

    /* ---------- 滚动 ---------- */
    scroll_to_bottom () {
      this.$nextTick(() => {
        const box = this.$el.querySelector('.chat-content')
        if (box) box.scrollTop = box.scrollHeight
      })
    },

  }
}
</script>
<style scoped lang="css" src="./assets/index.response.css" />
<style scoped lang="css" src="./assets/candidate.css" />
<style scoped lang="scss">
.main-container {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  scrollbar-width: none;
  -ms-overflow-style: none;
  box-sizing: border-box;
}

.chat-container {
  display: flex;
  width: 100%;
  height: calc(100vh - 180px); /* 固定高度，减去页面其他部分的高度（包括header和tab） */
  min-height: 500px;
  background-color: transparent;
  gap: 24px;
  box-sizing: border-box;
  overflow-x: hidden; /* 防止横向滚动 */

  .left-panel {
    flex: 0 0 35%;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden; /* 防止整个面板滚动 */
    padding: 0;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    border: none;
    position: relative;
    box-sizing: border-box;
  }


  .chat-info {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    margin-left: 0;
    width: 100%;
  }

  .name-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    min-width: 0;
  }

  .name {
    font-weight: 600;
    font-size: 15px;
    line-height: 1.4;
    color: #2D2D2D;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    letter-spacing: 0.2px;
  }
  
  .tag-container {
    display: flex; 
    gap: 8px;
    flex-wrap: wrap;
    align-items: center;
  }

  .tag {
    display: inline-flex;
    align-items: center;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    color: #666;
    padding: 4px 10px;
    background: #f5f5f5;
    border: 1px solid #e8e8e8;
    white-space: nowrap;
    transition: all 0.2s;
    height: 22px;
    line-height: 1;
    
    &.company-tag {
      color: #7EB4EB;
      background: linear-gradient(135deg, rgba(126, 180, 235, 0.12) 0%, rgba(126, 180, 235, 0.06) 100%);
      border-color: rgba(126, 180, 235, 0.4);
      font-weight: 500;
    }
    
    &.job-tag {
      color: #B16EF9;
      background: linear-gradient(135deg, rgba(177, 110, 249, 0.12) 0%, rgba(177, 110, 249, 0.06) 100%);
      border-color: rgba(177, 110, 249, 0.4);
      font-weight: 500;
    }
  }

  .message-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 6px;
    gap: 12px;
  }

  .last-message {
    flex: 1;
    font-size: 13px;
    color: #999;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
    font-weight: 400;
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    
    .interview-record-icon {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
  }

  .timestamp {
    font-size: 12px;
    color: #999;
    white-space: nowrap;
    flex-shrink: 0;
    font-weight: 400;
    line-height: 1.5;
    font-family: 'SF Mono', 'Monaco', 'Menlo', monospace;
  }


  .avatar-container {
    margin-right: 12px;
    flex-shrink: 0;
    position: relative;
    width: 48px;
    height: 48px;
  }

  .message-avatar {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    object-fit: cover;
    border: 2px solid #f0f0f0;
    background: #f5f5f5;
  }


  .unread-dot {
    position: absolute;
    top: -2px;
    right: -2px;
    width: 10px;
    height: 10px;
    background: linear-gradient(135deg, #ff4757 0%, #ff6b7a 100%);
    border-radius: 50%;
    border: 2px solid white;
    z-index: 3;
    box-shadow: 0 2px 4px rgba(255, 71, 87, 0.5);
    animation: pulse 2s infinite;
  }
  
  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.1);
      opacity: 0.8;
    }
  }


  .right-panel {
    margin-left: 0;
    margin-top: 0;
    flex: 1;
    min-width: 0;
    box-sizing: border-box;
    border-radius: 12px;
    box-shadow: none;
    background: white;
    border: none;
    display: flex;
    flex-direction: column;
    overflow: hidden; /* 防止整个面板滚动 */
    position: relative;
    height: 100%;
  }




  .chat-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: white;
    border-radius: 12px 12px 0 0;
    flex-shrink: 0;
    border-bottom: 1px solid #e8e8e8;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  }

  .user-info {
    display: flex;
    flex-direction: row;
    gap: 4px;
  }

  .user-name {
    font-family: Afacad;
    font-weight: 600;
    font-size: 18px;
    color: #2D2D2D;
  }

  .company-tag {
    display: inline-block;
    padding: 4px 8px;
    background: rgba(177, 110, 249, 0.1);
    border: 1px solid #B16EF9;
    border-radius: 6px;
    font-size: 12px;
    color: #B16EF9;
    font-weight: 500;
    width: fit-content;
  }

  .typing-status {
    font-size: 14px;
    color: #999;
    font-style: italic;
  }

  .action-buttons {
    display: flex;
    align-items: center;
  }

  .action-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border: none;
    background: transparent;
    border-radius: 6px;
    font-size: 14px;
    color: #656587;
    cursor: pointer;
    transition: all 0.2s;

    img {
      width: 18px;
      height: 18px;
      opacity: 0.6;
      transition: opacity .2s ease;
    }

    &.active {
      color: #B16EF9;
      background: rgba(177, 110, 249, 0.1);

      img { opacity: 1; }
    }

  }

  .user-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid #E8E8F0;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .view-resume {
    padding: 5px 10px;
    cursor: pointer;
    font-family: Afacad;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    color: #00000066;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: background-color 0.2s;
    border-radius: 5px;

    &:hover {
      background-color: rgba(177, 110, 249, 0.1);
    }
  }

  .chat-content {
    overflow-y: auto;
    padding: 20px;
    flex: 1;
    background: linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);
    border-radius: 0px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #a1a1a1;
    }
  }

  /* 顶部岗位信息条 */
  .job-top-bar {
    position: sticky;
    top: 0;
    z-index: 5;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 20px;
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
    flex-shrink: 0;
    border-radius: 0;
  }
  .job-top {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
    width: 100%;
  }
  .job-top-first {
    display: flex;
    flex-direction: row;
    gap: 8px;
    min-width: 0;
    justify-content: space-between;
    align-items: center;
  }
  .job-top-second{
    display: flex;
    justify-content: space-between;
  }
  .job-title-row { display:flex; align-items:center; gap:8px;margin-bottom: 4px }
  .job-title { font-size: 18px; font-weight: 700; color:#2D2D2D; }
  .pill { display:inline-flex; align-items:center; height:22px; padding:0 8px; border-radius:4px; font-size:12px; }
  .pill-primary { background: rgba(177,110,249,.12); color:#7b4fe8; border:1px solid rgba(177,110,249,.35); }
  .job-meta-row { display:flex; flex-wrap:wrap; gap:8px; }
  .meta-pill { display:inline-flex; align-items:center; height:22px; padding:0 8px; border-radius:4px; background:#f6f7fb; color:#777; font-size:12px; border:1px solid #eee; }
  .company-row { display:flex; align-items:center; gap:10px; margin-top:2px; }
  .company-detail{ display: flex;flex-direction: column;align-items: flex-end;}
  .company-logo { width:28px; height:28px; border-radius:6px; object-fit:cover; }
  .company-logo-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, rgba(126, 180, 235, 0.1) 0%, rgba(177, 110, 249, 0.1) 100%);
    color: #656587;
    font-size: 10px;
    font-weight: 600;
    flex-shrink: 0;
  }
  .company-info { display:flex; flex-direction:column; gap:2px;align-items: flex-start; }
  .company-name { font-size:14px; font-weight:600; color:#333; }
  .company-desc { font-size:12px; color:#888;max-width:200px }

  .job-top-right { display:flex; flex-direction:column; align-items:flex-end; gap:6px; white-space:nowrap; }
  .salary { font-size:20px; font-weight:700; background: linear-gradient(90deg,#7EB4EB,#B16EF9); background-clip:text; -webkit-background-clip:text; color: transparent; -webkit-text-fill-color: transparent; }
  .icon-text { display:flex; align-items:center; gap:6px; font-size:12px; color:#666;margin-bottom: 4px; }
  .icon-text .ellipsis { max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block; }
  .icon-text-row { display:flex; align-items:center; margin-right: 8px; }
  .i16 { width:16px; height:16px; display:inline-block; background:#cfd3dc; border-radius:3px; }
  /* 预留图标类（如后续替换为真实图标，可在此设置背景图） */

  .date-divider {
    text-align: center;
    margin: 30px 0 10px 0;
    color: #999;
    font-size: 12px;
    position: relative;
  }

  .message-item {
    margin-bottom: 15px;
    display: flex;
    max-width: 80%;
    align-items: center;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .mine {
    flex-direction: row-reverse;
    margin-left: auto;
  }

  .other {
    justify-content: flex-start;
    margin-right: auto;
  }

  .message-bubble {
    display: flex;
    flex-direction: column;
  }

  .text{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  

  /* 个人信息聚合消息样式 */
  .profile-aggregate {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 12px;
    background: #fff;
    border: 1px solid #e9e9ee;
    border-radius: 12px;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
  }
  .pa-left { display:flex; flex-direction:column; gap:10px; min-width:0; }
  .pa-title { font-size:16px; font-weight:700; color:#2D2D2D; }
  .pa-user { display:flex; align-items:center; gap:10px; }
  .pa-avatar { width:36px; height:36px; border-radius:50%; object-fit:cover; }
  .pa-user-info { display:flex; flex-direction:column; gap:2px; }
  .pa-name-row { display:flex; align-items:center; gap:6px; font-size:14px; color:#333; font-weight:600; }
  .pa-sep { color:#999; font-weight:400; }
  .pa-basic { font-size:12px; color:#777; font-weight:400; }
  .pa-graduate { font-size:12px; color:#6b45e4; }
  .pa-tags { display:flex; flex-wrap:wrap; gap:8px; }
  .pa-tag { 
    display:inline-flex; 
    align-items:center; 
    height:22px; 
    padding:0 8px; 
    font-size:12px; 
    background: transparent;
    border: 1px solid;
    border-image: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%) 1;
  }
  .pa-right {
    display:flex;
    align-items:center;
    gap:12px;
    border-radius:12px;
    padding:8px 12px 8px 60px; 
    position: relative;
    width: 120px;
    background-image: url('../Interview_Analysis//assets/img/score.png');
    background-repeat: no-repeat;
    background-position: 12px center;
    background-size: 100px;
  }
  .pa-score { 
    font-size:24px; 
    font-weight:800; 
    position: absolute; 
    left:34px; 
    bottom:24px;
    background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .message-text {
    padding: 12px 16px;
    border-radius: 12px;
    margin: 0;
    max-width: 100%;
    word-wrap: break-word;
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    white-space: normal;
  }

  .message-image {
    padding: 5px;
    border-radius: 12px;

    .message-img {
      max-width: 200px;
      max-height: 200px;
      border-radius: 12px;
      cursor: pointer;
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .message-file {
    padding: 12px 16px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.8);
    border: 1px solid #e0e0e0;
    max-width: 300px;

    .file-link {
      display: flex;
      align-items: center;
      text-decoration: none;
      color: #656587;

      .file-icon {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }

      .file-info {
        flex: 1;
        overflow: hidden;

        .file-name {
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          font-weight: 400;
        }

        .file-size {
          display: block;
          font-size: 12px;
          color: #999;
        }
      }

      &:hover {
        color: #7EB4EB;
      }
    }
  }

  .other .message-text,
  .other .message-file {
    background: linear-gradient(320.78deg, rgba(255, 255, 255, 0.8) 2.06%, rgba(255, 255, 255, 0.5) 99.08%);
    border: 1px solid #e0e0e0;
  }

  .mine .message-text,
  .mine .message-file {
    background: linear-gradient(320.78deg, rgba(177, 110, 249, 0.2) 2.06%, rgba(126, 180, 235, 0.2) 99.08%);
    border: 1px solid #d8c5f7;
    border-top-right-radius: 0;
  }

  .message-meta {
    display: flex;
    justify-content: flex-end;
    margin-top: 4px;
    padding: 0 8px;
  }

  .mine .message-meta {
    justify-content: flex-end;
  }

  .other .message-meta {
    justify-content: flex-start;
  }

  .read-status {
    font-size: 12px;
    color: #999;
    margin: 0;
    display: inline-flex;
    align-items: center;
  }
  
  .read-icon {
    width: 14px;
    height: 14px;
    display: inline-block;
    vertical-align: middle;
  }

  .other-avatar {
    margin-right: 10px;
    margin-left: 0;
  }

  .my-avatar {
    margin-left: 10px;
    margin-right: 0;
  }

  .input-bar {
    padding: 16px 20px;
    border-top: 1px solid #e8e8e8;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.02);
    margin-top: auto;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex-shrink: 0;
    border-radius: 0 0 12px 12px;
  }

  .input-icons {
    display: flex;
    gap: 8px;
    align-items: center;
    
    img {
      border-radius: 8px;
      padding: 4px;
      transition: all 0.2s;
      
      &:hover {
        background: rgba(126, 180, 235, 0.1);
      }
    }
  }

  .input-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: #f8f9fa;
    border-radius: 12px;
    padding: 12px;
  }

  .send-button-container {
    display: flex;
    justify-content: flex-end;
  }

  .submit-interview-btn {
    padding: 6px 12px;
    border: 1px solid #B16EF9;
    border-radius: 6px;
    background: transparent;
    color: #B16EF9;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: rgba(177, 110, 249, 0.1);
    }
  }

  .input-message {
    width: 100%;
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 14px;
    color: #656587;
    min-height: 40px;
    max-height: 80px;
    resize: none;
    overflow-y: auto;
    font-family: inherit;
    line-height: 1.4;

    &::placeholder {
      color: #bbb;
    }
  }

  .send-emoji,
  .send-attachment {
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px;
    margin: 0 5px;
    transition: all 0.2s;

    &:hover {
      transform: scale(1.1);
    }
  }

  .send-button {
    background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
    color: white;
    border: none;
    border-radius: 20px;
    padding: 8px 20px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;

    &:hover {
      opacity: 0.9;
      transform: scale(1.05);
    }

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
      transform: none;
      opacity: 1;
    }
  }

  .empty-chat {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    background: linear-gradient(135deg, rgba(126, 180, 235, 0.02) 0%, rgba(177, 110, 249, 0.02) 100%);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle, rgba(126, 180, 235, 0.05) 0%, transparent 70%);
      animation: float 20s ease-in-out infinite;
    }

    .empty-chat-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 20px;
      z-index: 1;
      padding: 40px;
    }

    .empty-chat-icon {
      opacity: 0.6;
      animation: fadeInUp 0.6s ease-out;
    }

    .empty-chat-text {
      font-size: 18px;
      font-weight: 500;
      color: #666;
      margin: 0;
      background: linear-gradient(135deg, #7EB4EB 0%, #B16EF9 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      animation: fadeInUp 0.6s ease-out 0.2s both;
    }

    .empty-chat-hint {
      font-size: 14px;
      color: #999;
      margin: 0;
      text-align: center;
      line-height: 1.6;
      animation: fadeInUp 0.6s ease-out 0.4s both;
    }
  }

  @keyframes float {
    0%, 100% {
      transform: translate(0, 0) rotate(0deg);
    }
    50% {
      transform: translate(30px, 30px) rotate(180deg);
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

/* 表情包面板样式 */
.emoji-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: transparent;
}

.emoji-panel {
  position: absolute;
  bottom: 70px;
  left: 10px;
  right: 10px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
}

.emoji-category {
  margin-bottom: 10px;
}

.emoji-title {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.emoji-grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 5px;
}

.emoji-item {
  font-size: 18px;
  text-align: center;
  padding: 5px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f0f0;
  }
}

/* 隐藏的文件上传输入 */
.hidden-file-input {
  display: none;
}

/* 图片预览模态框 */
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.preview-content {
  max-width: 90%;
  max-height: 90%;
}

.preview-img {
  max-width: 100%;
  max-height: 80vh;
  border-radius: 5px;
}

.content-body {
  flex: 1;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  overflow-x: hidden; /* 防止横向滚动 */
  width: 100%;
  box-sizing: border-box;
}

/* 顶部状态筛选tab样式 */
.top-status-tabs {
  display: flex;
  align-items: flex-end;
  gap: 0;
  padding: 0;
  margin-bottom: 0;
  border-bottom: 1px solid #e8e8e8;
  flex-wrap: nowrap;
  background: white;
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  flex-shrink: 0;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
  border-radius: 12px 12px 0 0;
  /* 确保tab只在left-panel内，不超出 */
  contain: layout;
}

.status-tab-item {
  padding: 16px 24px;
  font-size: 15px;
  color: #666;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  position: relative;
  flex-shrink: 0;
  background: transparent;
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: -2px;
  border-radius: 8px 8px 0 0;

  &:hover:not(.active) {
    color: #7EB4EB;
    background: rgba(126, 180, 235, 0.04);
  }

  &.active {
    color: #7EB4EB;
    font-weight: 500;
    border-bottom: 3px solid #7EB4EB;
    background: rgba(126, 180, 235, 0.06);
  }

  .tab-count {
    color: #ff4757;
    font-weight: 600;
    margin-left: 6px;
    font-size: 12px;
    background: rgba(255, 71, 87, 0.1);
    padding: 2px 6px;
    border-radius: 10px;
    line-height: 1.2;
  }
}

/* 消息列表包装器 */
.chat-list-wrapper {
  flex: 1;
  overflow: hidden;
  min-height: 0;
}

/* Element UI 列表组件样式 */
.chat-list {
  height: 100%;
  background: #fff;
  border: none;
  padding: 0;
}

/* 选中状态样式 - 直接选择 chat-list-item.list-item-active */
.chat-list-item.list-item-active {
  background: rgba(126, 180, 235, 0.15) !important;
  position: relative !important;
  z-index: 1;
}

.chat-list-item.list-item-active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 6px;
  bottom: 6px;
  width: 4px;
  background: linear-gradient(180deg, #7EB4EB 0%, #B16EF9 100%);
  border-radius: 0 4px 4px 0;
  z-index: 10;
}





.list-item-content {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  transition: all 0.3s ease;
}

.chat-list-item {
  display: block;
  width: 100%;
  padding: 0;
  border-radius: 0;
  background: transparent;
  border: none;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
  margin-bottom: 0;
  box-sizing: border-box;
  position: relative;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: auto;
  box-shadow: none;
}

.chat-list-item:last-child {
  border-bottom: none;
}

.chat-list-item:hover:not(.list-item-active) {
  background: rgba(126, 180, 235, 0.03);
}

.empty-list {
  padding: 60px 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
  
  p {
    margin: 0;
    color: #bbb;
    font-size: 13px;
  }
}

/* 常用语面板样式 */
.frequent-panel {
  position: fixed;
  bottom: 146px;
  left: 0;
  right: 0;
  background: white;
  border-radius: 20px 20px 0 0;
  z-index: 1001;
  max-height: 60vh;
  overflow: hidden;
  animation: slideUpFromBottom 0.3s ease-out;
}

@keyframes slideUpFromBottom {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 背景遮罩层 */
.frequent-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.frequent-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 8px 20px;
}

.frequent-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.frequent-close {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  border: none;
  color: white;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.frequent-close:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(98, 175, 255, 0.4);
}

.frequent-content {
  padding: 0 20px 20px 20px;
  max-height: calc(60vh - 80px);
  overflow-y: auto;
}

.frequent-list {
  margin-bottom: 16px;
}

.frequent-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
}

.frequent-item:last-child {
  border-bottom: none;
}

.phrase-text {
  flex: 1;
  font-size: 14px;
  color: #333;
  line-height: 1.4;
  margin-right: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.phrase-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
}


.modify-btn {
  background: transparent;
  color: #666;
  padding: 4px 8px;
  border: none;
}

.modify-btn:hover {
  background: transparent;
  color: #2196f3;
}

.send-btn {
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  color: white;
  border: 1px solid transparent;
  padding: 6px 12px;
  border-radius: 6px;
}

.send-btn:hover {
  opacity: 0.9;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(98, 175, 255, 0.4);
}


.add-phrase-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border: 2px dashed #62AFFF;
  border-radius: 12px;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #62AFFF;
  font-size: 14px;
}

.add-phrase-box:hover:not(.disabled) {
  border-color: #9C41FF;
  color: #9C41FF;
  background: rgba(98, 175, 255, 0.05);
}

.add-phrase-box.disabled {
  border-color: #ccc;
  color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

::v-deep .el-dialog{
  border-radius: 40px
}

::v-deep .modify-phrase-dialog .el-dialog__body{
  padding: 40px 40px 20px 40px;
}

.add-phrase-box span:last-child {
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 500;
}

/* Element UI 修改常用语弹框自定义样式 */
.modify-phrase-dialog {
  border-radius: 16px;
}

.report-intro{
  margin-bottom: 24px;
}





.modify-phrase-dialog .el-dialog__footer {
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modify-phrase-dialog .dialog-footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modify-phrase-dialog .footer-left {
  display: flex;
}

.modify-phrase-dialog .footer-right {
  display: flex;
  gap: 12px;
}


.modify-phrase-dialog .dialog-footer .el-button--primary:hover {
  opacity: 0.9;
}

// 自定义删除聊天弹框样式
.delete-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.delete-dialog {
  background-color: white;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: 445px;
}

.dd-figure {
  width: 60px;
  height: 60px;
  background-color: #ff7b7b;
  border-radius: 50%;
  margin: 0 auto 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dd-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.dd-desc {
  font-size: 14px;
  color: #656587CC;
  margin: 4px;
}

.dd-actions {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 6px;
}

.dd-btn {
  padding: 4px 0;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  flex: 1;
}
.dd-cancel{
  border: 1px solid #656587;
}

// 举报聊天弹框样式
.report-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.report-dialog {
  background-color: white;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: 445px;
}

.rd-figure {
  width: 60px;
  height: 60px;
  background-color: #ff7b7b;
  border-radius: 50%;
  margin: 0 auto 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rd-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.rd-desc {
  font-size: 14px;
  color: #656587CC;
  margin: 4px;
}

.rd-actions {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 6px;
}

.modify-phrase-dialog .dialog-footer .el-button {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  flex: 1;
}
.rd-cancel{
  border: 1px solid #656587;
}

.modify-phrase-dialog .dialog-footer .el-button--default {
  border: 2px solid #9C41FF;
  color: #9C41FF;
  background: white;
}

.modify-phrase-dialog .dialog-footer .el-button--primary {
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  border: none;
  color: white;
}

::v-deep .report-el-dialog .el-dialog__footer {
  padding: 16px 24px !important;
}
::v-deep .report-el-dialog .el-dialog__body {
  padding: 24px 40px;
  .el-select{
    width: 100%;
  }
}

::v-deep .report-el-dialog .el-dialog__header {
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  border-radius: 40px 40px 0 0 ;
  color: #fff;
  padding: 24px;
  .dialog-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  span{
    font-size: 24px;

  }
}

.report-footer{
  display: flex;
  align-items: center;
  justify-content: space-between;
  button{
    flex: 1
  }
}
</style>
